import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  LinearProgress,
  Button,
  FormControlLabel,
  Checkbox,
  IconButton,
  Stack,
  Divider,
  Box
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CloseIcon from '@mui/icons-material/Close';

const ValidationProgressDialog = ({
                                    open,
                                    onClose,
                                    onSave,
                                    success,
                                    isValidating,
                                    recalculationOptions,
                                    onRecalcOptionChange,
                                    configForSave
                                  }) => {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={onClose}>
      <Box sx={{
        marginTop: 5,
        marginBottom: 1,
        marginLeft: 5,
        marginRight: 5,
      }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 30,
            right: 30,
            backgroundColor: '#333333',
            padding: '4px',
            zIndex: 1,
            '&:hover': {
              backgroundColor: '#444444',
            },
          }}
        >
          <CloseIcon sx={{ color: '#ffffff', fontSize: '1.2rem' }} />
        </IconButton>

        <DialogContent sx={{ padding: '2rem 2rem 1.5rem 1rem'}}>
          <Grid container spacing={2}>


            {!success ? (
              <Grid item xs={12}>
                <Typography sx={{ mb: 1 }}>Validating configuration.....</Typography>
                <LinearProgress />
              </Grid>
            ) : (
              <>
                <Grid item xs={12}>
                  <Typography sx={{ fontWeight: 700, fontSize: '1.4rem' }}>
                    {success ? 'Configuration Validated' : 'Validating Configuration'}
                  </Typography>
                </Grid>

                <Grid item xs={12} sx={{ paddingTop: '5px !important', paddingBottom: '4px !important' }}>
                  <Divider sx={{ borderBottom: '2px solid black' }} />
                </Grid>
                <Grid item xs={12} container spacing={2} alignItems="center">
                  <Grid item>
                    <CheckCircleOutlineIcon color="success" fontSize="large" />
                  </Grid>
                  <Grid item xs>
                    <Typography variant="body1" sx={{ fontWeight: 500, fontSize: '1.1rem' }}>
                      Configurations validated successfully!
                    </Typography>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="subtitle1" sx={{ mt: 1, mb: -1 }}>
                    Would you like to calculate the following?
                  </Typography>
                </Grid>

                <Grid item xs={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={recalculationOptions.recalculate_trends}
                        onChange={onRecalcOptionChange}
                        name="recalculate_trends"
                        color="primary"
                        disabled={
                          !configForSave || configForSave['date_column'] === ''
                        }
                      />
                    }
                    label="Calculate Trends"
                  />
                </Grid>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={recalculationOptions.recalculate_opportunities}
                        onChange={onRecalcOptionChange}
                        name="recalculate_opportunities"
                        color="primary"
                        disabled={
                          !configForSave ||
                          configForSave['mean_feature_for_opportunity'] === '' ||
                          (configForSave['levers'] &&
                            configForSave['levers'].length === 0)
                        }
                      />
                    }
                    label="Calculate Opportunities"
                  />
                </Grid>
              </>
            )}
          </Grid>
        </DialogContent>

        <DialogActions sx={{ pr: 3, pb: 2 }}>
          <Button onClick={onClose} disabled={isValidating}>
            Cancel
          </Button>
          {success && (
            <Button
              onClick={onSave}
              color="primary"
              variant="contained"
              startIcon={<SaveIcon />}
            >
              Save Configurations
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default ValidationProgressDialog;
